module.exports = __webpack_public_path__ + "img/entrance_plant_1@2x.a0146ce1.jpg";